import { MinusSquare } from '@styled-icons/fa-regular/MinusSquare';
import { Star } from '@styled-icons/fa-regular/Star';
import { StickyNote } from '@styled-icons/fa-regular/StickyNote';
import { ChevronUp } from '@styled-icons/fa-solid';
import { Bolt } from '@styled-icons/fa-solid/Bolt';
import { Cog } from '@styled-icons/fa-solid/Cog';
import { Exclamation } from '@styled-icons/fa-solid/Exclamation';
import { GasPump } from '@styled-icons/fa-solid/GasPump';
import { Lock } from '@styled-icons/fa-solid/Lock';
import { UserPlus } from '@styled-icons/fa-solid/UserPlus';
import { Triangle } from '@styled-icons/feather/Triangle';
import { Circle } from '@styled-icons/feather/Circle';
import { Cross } from '@styled-icons/icomoon/Cross';
import { map } from 'lodash';
import React from 'react';
import styled from 'styled-components';
import CCF from '~/public/icons/CCF.png';
import CRF from '~/public/icons/CRF.png';
import CurrencyGaining from '~/public/icons/Currency-Gaining.png';
import CurrencyNotGained from '~/public/icons/Currency-Not-Gained.png';
import Hook from '~/public/icons/hook_icon.png';
import { getMaskedPhaseName } from 'services/flyproHelper';

const GreenTriangle = styled(Triangle)`
  color: green;
  fill: green;
  width: 13px;
`;

export const GreenCircle = styled(Circle)`
  color: green;
  fill: green;
  width: 13px;
`;

const GoldBolt = styled(Bolt)`
  color: black;
`;

const BlueCross = styled(Cross)`
  color: #5377bb;
  width: 13px;
  height: 10px;
`;

const BlackChevron = styled(ChevronUp)`
  color: black;
  width: 13px;
`;

const OrangeTriangle = styled(Triangle)`
  color: orange;
  fill: orange;
  transform: rotate(180deg);
  width: 13px;
`;

const ColorBlock = styled.span`
  width: 10px;
  height: 10px;
  display: block;
`;

const ExternalResourceWrapper = styled.span`
  font-weight: bold;
  font-size: 12px;
  padding-left: 1px;
`;

const StudentPriorityMarkWrapper = styled.span`
  border-radius: 5px;
  padding: 4px;
  font-size: 10px;
  color: white;
`;

export const IncompleteResourceIcon = styled(Exclamation)`
  color: orange;
  width: 10px;
  height: 10px;
`;

/**
 * Default messages for state banners
 */
export const bannerDefaults = {
  EMPTY: 'No data',
  ERROR: 'Oops! This component is crashed!',
  LOADING: 'Loading ...',
  UNKNOWN_STATE: 'INIT or unknown view state!\nIs this component initialized?',
};

/**
 * Base configuration for flypro
 */
export const baseConfigurations = [
  { code: 'AN', content: 'Any Configuration' },
  { code: 'AL', content: 'ALFS Aircraft' },
  { code: 'UT', content: 'Utility Aircraft' },
];

/**
 * Labels on the sidemenu
 */
export const sidemenuLabels = {
  AIRCREW: 'AIRCREW',
  PERSONNEL: 'PERSONNEL',
  AUTO_PLANNING_SETTINGS: 'Parameters',

  CAT_INPUTS: 'Cat Inputs',
  CAT_OUTPUTS: 'Cat Outputs',
  CAT_SIMULATION: 'Simulation',

  FACILITY_INPUTS: 'FACILITY INPUTS',
  FLY_PRO: 'Daily Schedule',
  FLY_PRO_MONTHLY: 'Monthly Schedule',
  INPUT_COHORTS: 'Cohorts',
  INPUT_FACILITY: 'Base',
  INPUT_FLIGHTS: 'Flights',
  INPUT_RESOURCES: 'Resources',
  INPUT_SCHOOLS: 'Squadrons',

  INPUT_SYLLABI: 'Activity Sets',
  INSTRUCTOR: 'Instructors',

  PLANNING_INPUTS: 'Planning Inputs',
  REPORTS: 'Reports',
  DASHBOARD_DATA_EXPORT: 'Dashboard Data Export',
  AVAILABILITY_DATA_EXPORT: 'Availability Data Export',
  SAR_SETTINGS: 'Ops Inputs',
  SCHEDULER_STUDENTS: 'Students',
  SECTION_OUTPUTS: 'CAPACITY ANALYSIS TOOL',
  SECTION_SHORT_TERM: 'OPERATIONS',
  STAFF_AIRCREW: 'Staff Aircrew',
  STUDENTS: 'Students',
  SUPPORT: 'Support',

  PERSONAL_SECTION: 'Personal Section',
  MY_PAGE: 'My Page',
  MY_COHORTS: 'My Cohorts',
  GROUPS: 'Groups',
  MY_FLIGHTS: 'My Flights',

  CONFIGURATIONS: 'Configurations',
  QUALIFICATIONS: 'Qualifications',
  MANAGED_ITEMS: 'Managed Items',
};

export const COHORTS_TABS = {
  COHORTS: 'Cohorts',
  STUDENT_TYPES: 'Student Types',
};

export const HUMAN_TABS = {
  COMMITMENTS: 'Commitments',
  EVENTS: 'Events',
  DUTIES: 'Duties',
  CURRENCIES: 'Currencies',
  AVAILABILITIES: 'Availabilities',
  ENROLMENTS: 'Enrolments',
  DETAILS: 'Details',
  PROPERTIES: 'Properties',
};

export const RESOURCE_TABS = {
  EVENTS: 'Events',
  AVAILABILITIES: 'Availabilities',
  DETAILS: 'Details',
};

export const LESSON_TABS = {
  DETAILS: 'Details',
  PHASES: 'Phases',
  PREREQUISITES: 'Prerequisites',
  SHARED_LESSONS: 'Shared Activities',
};

export const INSTRUCTOR_TABS = {
  INSTRUCTORS: 'Instructors',
  QUALIFICATIONS: 'Qualifications',
};

export const CONFIGURATIONS_TABS = {
  CONFIGS: 'Resource Configs',
  QUALIFICATIONS: 'Personnel Qualifications',
};

/**
 * Resource type tabs
 */
export const RESOURCE_TYPE_TABS = {
  AVAILABILITY: 'Availability',
  DETAILS: 'Details',
  RESOURCE_INSTANCES: 'Assets',
};

export const STAFF_AIRCREW_TABS = {
  STAFF_AIRCREW: 'Staff Aircrew',
  QUALIFICATIONS: 'Qualifications',
};

export const STUDENT_DETAIL_TABS = {
  AVAILABILITY: 'Availability',
  DETAILS: 'Details',
  EVENTS: 'Events',
  LESSONS: 'Activities',
};

export const SAR_TABS = {
  SAR: 'SAR',
  DUTY_TEMPLATES: 'Duty Templates',
  STICKY_NOTE_TEMPLATES: 'Sticky Note Templates',
};

export const SQUADRON_TABS = {
  COHORTS: 'Cohorts',
  PROPERTIES: 'Details',
  RESOURCES: 'Resources',
  UNAVAILABILITY: 'Unavailabilities',
};

export const STUDENTS_TABS = {
  CURRENT: 'Current',
  GRADUATED: 'Graduated',
  NOT_COMPLETED: 'Not Completed',
  DORMANT: 'Dormant',
  ARCHIVED: 'Archived',
};

export const SYLLABUS_TABS = {
  DETAILS: 'Details',
  LESSONS: 'Activities',
  MODULES: 'Modules',
};

/**
 * Tab labels on the simulation page
 */
export const simulationTabs = {
  OUTPUTS: 'Outputs',
  POLICY: 'Rules',
  PARAMS: 'Execution',
  FLAGS: 'Flags',
  STRATEGIES: 'Strategies',
  ADDITIONAL: 'Prioritisation',
  DEFAULTS: 'Defaults',
};

export const simulationOutputTabs = {
  COHORTS_DURATION: 'Cohorts Duration',
  TRAINEES_TIME_SPENT: 'Trainees Time Spent',
  RESOURCE_UTILISATION: 'Resource Utilisation',
  INSTRUCTOR_UTILISATION: 'Instructor Utilisation',
};

/**
 * Banner messages for the CAT Outputs page's simulation-result readiness states
 */
export const catOutputsMessages = {
  NO_RESULTS: 'No simulation results are available for this dataset yet.',
  PROCESSING: 'Simulation results are still being processed. This page will update automatically.',
  FAILED: 'The simulation failed to complete. Please re-run the simulation.',
  CANCELLED: 'The simulation was cancelled before completing.',
  CHECK_ERROR: 'Unable to check simulation status right now. Retrying...',
};

/**
 * Form error messages
 */
export const formErrorMessages = {
  DUPLICATE_PMKEYS: 'Personnel needs to have unique PMKeyS',
  GREATER_THAN: (n) => `This field cannot be greater than ${n}.`,
  LATER_THAN: (n) => `This field cannot be later than ${n}.`,
  IS_GROUP_NAME_LIVE: () => `Group name can not be "Live"`,
  IS_NOT_AFTER_TODAY: 'Please input a date after today',
  IS_NOT_VALID_DATE: (limit) => `Day must be integer and can not be bigger than ${limit}`,
  IS_NOT_VALID_TIME: () => `End time cannot be earlier than start time`,
  IS_NOT_VALID_DATES: () => `End date cannot be before than start date`,
  IS_NULL: () => 'Please fill in this field',
  LENGTH_NOT_IN_RANGE: (min, max) => `This field should have length from ${min} to ${max}`,
  LESS_THAN: (n) => `This field cannot be less than ${n}.`,
  NOT_A_DECIMAL: () => 'This field requires a decimal.',
  NOT_A_NUMBER: () => 'This field requires a number.',
  NOT_AN_INTEGER: () => 'This field requires an integer',
  NOT_EMAIL: () => 'Please input a valid email address',
  NOT_EMPTY: () => 'This field can not be empty',
  NOT_POSITIVE: () => 'This field should be a number greater than 0',
  ZERO_OR_GREATER: () => 'This field can be zero or greater',
  NOT_SAME_PASSWORD: () => 'Please input same password',
  NOT_UNIQUE: () => 'This field should be unique',
  NOT_UNIQUE_SCENARIO_NAME: 'Scenario name must be unique',
  NOT_UNIQUE_DATASET_NAME: 'Dataset name must be unique',
  NOT_VALID_DATE: () => 'The date should be valid',
  NOT_VALID_STRING: () =>
    'The field can only contain letters, numbers, underscore, space and hyphen. No special characters are allowed and it should not start with a space ',
  NOT_VALID_USERNAME: () =>
    'The field can only contain letters, numbers, underscore, space, @ and dot. No other special characters are allowed and it should not start with a space ',
  DUPLICATE_STUDENTS: 'Duplicate Students!',
  SQUADRON_REQUIRED: 'Please select a Squadron!',
};

/**
 * Button tooltips
 */
export const buttonTooltips = {
  CREATE_DEFAULT: undefined, // No tooltip
  DELETE_DEFAULT: 'Delete',
  CREATE_ENROLMENT: 'Create new Enrolment',
  CREATE_FLYPRO_GROUP: 'Create Flypro Group',
  CREATE_ACTIVITY_REQUEST: 'Create Activity Request',
  CREATE_QUALIFICATION: 'Create new Qualification',
  CREATE_QUALIFICATION_TYPE: 'Create new Qualification Type',
  CREATE_QUALIFICATION_GROUP: 'Create new Qualification Group',
  ADD_QUALIFICATION_TO_GROUP: 'Add Qualification to Group',
  ADD_RESOURCE: 'Add Resource',
  ADD_COURSE_MANAGER: 'Add Course Manager to Cohort',
  ADD_FLIGHT_MANAGER: 'Add Flight Manager to Flight',

  CREATE_CONFIG: 'Create new Config',
  CREATE_CONFIG_TYPE: 'Create new Config Type',
  CREATE_CONFIG_GROUP: 'Create new Config Group',
  ADD_CONFIG_TO_GROUP: 'Add Config to Group',
  CREATE_CURRENCY_EVENT: 'Create new Currency Event',
  CREATE_DATASET: 'Create new Scenario',
  CREATE_INSTRUCTOR_TYPE: 'Create new Instructor type',
  CREATE_RESOURCE_TYPE: 'Create new Resource Type',
  CREATE_STAFF_AIRCREW_TYPE: 'Create new Staff Aircrew type',
};

/**
 * Event card designation
 * @type {[]}
 */
export const EventCardDesignations = [
  { code: 'G#', content: '725/Gauntlet Flying Event' },
  { code: 'T#', content: '816/Tiger Flying Event' },
  { code: 'M#', content: 'Maintenance Event' },
  { code: 'S#', content: 'Simulator Event' },
  { code: 'B#', content: 'Brief Event' },
  { code: 'C#', content: 'Cohort Event' },
  { code: 'I#', content: 'Individual Event' },
];

export const EventCardIcons = [
  { code: <Cog size={11} />, content: 'Configurations' },
  {
    code: <ExternalResourceWrapper style={{ color: 'red' }}>E</ExternalResourceWrapper>,
    content: 'External resources require organisation',
  },
  {
    code: <ExternalResourceWrapper style={{ color: '#0cc30c' }}>E</ExternalResourceWrapper>,
    content: 'External resources organised',
  },
  { code: <GasPump size={11} />, content: 'Fuel' },
  { code: <Lock size={11} />, content: 'Locked' },
  { code: <StickyNote size={11} />, content: 'Notes' },
  { code: <UserPlus size={11} />, content: 'Passengers' },
  { code: <IncompleteResourceIcon style={{ height: '11px', width: '11px' }} />, content: 'Resources incomplete' },
];

export const EventCardTileColors = [
  { code: <ColorBlock style={{ backgroundColor: '#ffffcc' }} />, content: 'High Priority Event' },
  { code: <ColorBlock style={{ backgroundColor: '#ccffcc' }} />, content: 'External Resources Required' },
  { code: <ColorBlock style={{ backgroundColor: '#f2f2f2' }} />, content: 'FCF/GR Event' },
  { code: <ColorBlock style={{ backgroundColor: '#f2ccff' }} />, content: 'High Priority Student Scheduled' },
  { code: <ColorBlock style={{ backgroundColor: '#ccf2ff' }} />, content: 'Students Scheduled' },
  { code: <ColorBlock style={{ backgroundColor: '#ffe6cc' }} />, content: 'Default' },
];

/**
 * Light configurations
 * @type {*[]}
 */
export const LightConfigurations = [
  { code: 'Day', content: 'Start of Civil Twilight (First Light) to End of Civil Twilight (Last Light) ' },
  { code: 'Night', content: 'End of Civil Twilight (Last Light) to End of Astronomical Twilight ' },
  { code: 'Night – No Solar Illumination', content: 'End of Astronomical Twilight to Start of Astronomical Twilight' },
  { code: 'Night', content: 'Start of Astronomical Twilight to Start of Civil Twilight (First Light) ' },
];

/**
 * Configuration codes for required system
 */
export const requiredSystemsConfiguration = [
  { code: 'A', content: 'Aft Troop Seat' },
  { code: 'C', content: 'Cargo Hook' },
  { code: 'D', content: 'ALFS Dipping' },
  { code: 'I', content: 'Instructors Seat' },
  { code: 'O', content: 'Optical Tracker' },
  { code: 'R', content: 'Rocket Pod' },
  { code: 'S', content: 'Sonobuoy Launcher' },
  { code: 'V', content: 'VOR/ILS' },
  { code: 'W', content: 'Wet Winching' },
  { code: 'w', content: 'Box Knocking' },
];

/**
 * Stores configuration codes
 */
export const storesConfiguration = [
  { code: 'X', content: 'Auxillary Tank' },
  { code: 'T', content: 'Torpedo (REXTORP/As per Firing Order' },
  { code: 'H', content: 'Hellfire (CATM/As per Firing Order)' },
  { code: 'G', content: 'GAU 21' },
  { code: 'g', content: 'MAG 58' },
  { code: 'M', content: 'Marker Marine' },
  { code: 'XX', content: 'CMDS Load Number' },
];

export const TAG_ICONS = {
  CURRENCY_GAINED: {
    icon: <img src={CurrencyGaining} height="13" width="13" alt="Currency Gained" />,
    description: 'Currency Gained',
    value: 'CURRENCY_GAINED',
  },
  NCG: {
    icon: <img src={CurrencyNotGained} height="13" width="13" alt="NCG - No Currency Gained" />,
    description: 'NCG - No Currency Gained',
    value: 'NCG',
  },
  CRF: {
    icon: <img src={CRF} height="13" width="13" alt="CRF - Currency Regaining Flight" />,
    description: 'CRF - Currency Regaining Flight',
    value: 'CRF',
  },
  CCF: {
    icon: <img src={CCF} height="13" width="13" alt="CCF - Currency Check Flight" />,
    description: 'CCF - Currency Check Flight',
    value: 'CCF',
  },
};

/**
 * Tags keys to display in key panel
 */
export const tagsKeys = map(TAG_ICONS, (tag) => ({
  code: tag.icon,
  content: tag.description,
}));

/**
 * Currency reports name colors
 */
export const currencyReportsColors = [
  { code: <ColorBlock style={{ backgroundColor: 'red' }} />, content: 'Flight Required' },
  { code: <ColorBlock style={{ backgroundColor: 'gold' }} />, content: '<15 days' },
  { code: <ColorBlock style={{ backgroundColor: 'green' }} />, content: '15-30 days' },
  { code: <ColorBlock style={{ backgroundColor: 'blue' }} />, content: '>30 days' },
];

export const activityRequestsPriorityColors = {
  RED: '#ff8585',
  ORANGE: '#ffd079',
  YELLOW: '#ffffc3',
  GREEN: '#cff9cf',
  LIGHTBLUE: '#bce4f8',
};

export const activityRequestsPriorityColorBlock = [
  { code: <ColorBlock style={{ backgroundColor: activityRequestsPriorityColors.RED }} />, content: '1' },
  { code: <ColorBlock style={{ backgroundColor: activityRequestsPriorityColors.ORANGE }} />, content: '2-5' },
  { code: <ColorBlock style={{ backgroundColor: activityRequestsPriorityColors.YELLOW }} />, content: '6-10' },
  { code: <ColorBlock style={{ backgroundColor: activityRequestsPriorityColors.GREEN }} />, content: '11-20' },
  { code: <ColorBlock style={{ backgroundColor: activityRequestsPriorityColors.LIGHTBLUE }} />, content: '21+' },
];

export const activityRequestsPriorityColorCodes = [
  { range: [undefined, 1], color: activityRequestsPriorityColors.RED },
  { range: [2, 5], color: activityRequestsPriorityColors.ORANGE },
  { range: [6, 10], color: activityRequestsPriorityColors.YELLOW },
  { range: [11, 20], color: activityRequestsPriorityColors.GREEN },
  { range: [21, undefined], color: activityRequestsPriorityColors.LIGHTBLUE },
];

/**
 * Iconology icons
 * @type {{SQUARE: {icon: *, value: string, content: string}, TRIANGLE: {icon: *, value: string, content: string}, DIAMOND: {icon: *, value: string, content: string}, CROSS: {icon: *, value: string, content: string}, CIRCLE: {icon: *, value: string, content: string}}}
 */
export const ICONOLOGY_ICONS = {
  UP_CHEVRON: { icon: <BlackChevron />, value: 'UP_CHEVRON', content: 'AC' },
  TRIANGLE: {
    icon: <GreenTriangle size={13} style={{ color: 'green', fill: 'green' }} />,
    value: 'TRIANGLE',
    content: 'Change',
  },
  INVERTED_TRIANGLE: { icon: <OrangeTriangle />, value: 'INVERTED_TRIANGLE', content: 'Required' },
  CROSS: { icon: <BlueCross size={10} style={{ color: '#5377bb' }} />, value: 'CROSS', content: 'Tentative' },
  DIAMOND: { icon: <GoldBolt size={13} />, value: 'DIAMOND', content: 'User Defined' },
  HOOK: { icon: <img src={Hook} height="13" width="13" alt="Wireman" />, value: 'HOOK', content: 'Wireman' },
  SQUARE: { icon: <MinusSquare size="13" />, value: 'SQUARE', content: 'Default' },
};

/**
 * Personnel configuration legends
 */
export const iconology = [
  { code: <Star size="16" />, content: 'Student' },
  ...map(ICONOLOGY_ICONS, (icon) => ({ code: icon.icon, content: icon.content })),
];

/**
 * SAR configuration legends
 * @type {*[]}
 */
export const sarConfiguration = [
  { code: <ColorBlock style={{ backgroundColor: 'orange' }} />, content: 'Helo Based SAR' },
  { code: <ColorBlock style={{ backgroundColor: '#50AC32' }} />, content: 'Land Base SAR' },
  { code: <ColorBlock style={{ backgroundColor: 'grey' }} />, content: 'Mutual' },
  { code: <ColorBlock style={{ backgroundColor: '#2c81b7' }} />, content: 'Other' },
];

/**
 * Student priority marks
 * @type {*[]}
 */
export const StudentPriorityMarks = [
  {
    code: <StudentPriorityMarkWrapper style={{ backgroundColor: '#2cad2ca6' }}>C</StudentPriorityMarkWrapper>,
    content: 'Cohort',
  },
  {
    code: <StudentPriorityMarkWrapper style={{ backgroundColor: '#114da7c7' }}>S</StudentPriorityMarkWrapper>,
    content: 'Student',
  },
];

/**
 * Personnel color configuration
 * @type {[]}
 */
export const personnelConfiguration = [
  { code: <ColorBlock style={{ backgroundColor: '#ffff00' }} />, content: 'Availability' },
  { code: <ColorBlock style={{ backgroundColor: '#f200ff' }} />, content: 'Duty' },
  { code: <ColorBlock style={{ backgroundColor: '#0000ff' }} />, content: 'Event' },
  { code: <ColorBlock style={{ backgroundColor: '#a5adba' }} />, content: 'Free' },
  { code: <ColorBlock style={{ backgroundColor: '#ff8400' }} />, content: 'TMUFF' },
  { code: <ColorBlock style={{ backgroundColor: '#ff0000' }} />, content: 'Unavailability' },
];

/**
 * Global Tooltips
 */
export const GLOBAL_TOOLTIPS = {
  DATASET_GROUP_SELECT_TOOLTIP: 'Type to create a new group Or select one from the list',
  MODULE_STATUS: {
    COMPLETED: 'Module Status: Completed',
    PLANNED: 'Module Status: Planned',
    UNPLANNED: 'Module Status: In Progress',
  },
  ACTIVITY_SOFT_DELETED: 'Activity Soft Deleted',
};

/**
 * EmptyBanner Messages
 */
export const emptyBanners = {
  NO_LIVE_DATASET: 'No Live Dataset',
  NO_AUTO_SAVE_DATASET: 'No Auto Save Dataset',
  NO_DATASET: 'No Scenario',
  NO_DEFAULT_DATASET: 'No Default Dataset',
  NO_INELIGIBLE_LESSONS: 'No Ineligible Activities',
};

/**
 * Toast messages
 */
export const toastMessages = {
  AUTO_PLAN_JOB_FAILED: 'Auto plan job failed',
  AUTO_PLAN_JOB_COMPLETE_SUCCESS: 'Auto plan job completed successfully',
  AUTO_PLAN_JOB_ACCEPT_SUCCESS: 'Auto plan job accepted successfully',
  AUTO_PLAN_JOB_ACCEPT_FAILED: 'Failed to accept auto plan job',
  AUTO_PLAN_JOB_REJECT_SUCCESS: 'Auto plan job rejected successfully',
  AUTO_PLAN_JOB_REJECT_FAILED: 'Failed to reject auto plan job',
  VALIDATE_JOB_COMPLETE_SUCCESS: 'Validation completed successfully',
  VALIDATE_JOB_FAILED: 'Validation job failed',
  SIMULATE_JOB_COMPLETE_SUCCESS: 'Simulation job completed successfully',
  SIMULATE_JOB_FAILED: 'Simulation job failed',
  ACCOUNT_CREATE_FAILED: 'Account creation failed',
  ACCOUNT_CREATE_SUCCESS: 'Account creation successful',
  ACCOUNT_DELETE_FAILED: 'Account deletion failed',
  ACCOUNT_DELETE_SUCCESS: 'Account deletion successful',
  ACCOUNT_PASSWORD_ERROR: 'User password update failed',
  ACCOUNT_PASSWORD_SUCCESS: 'User password update successful',
  ACCOUNT_UPDATE_FAILED: 'Account update failed',
  ACCOUNT_UPDATE_SUCCESS: 'Account update successful',
  ACCOUNT_USER_DETAIL_ERROR: 'User detail update failed',
  ACCOUNT_USER_DETAIL_SUCCESS: 'User detail update successful',
  ACCOUNT_REMOVE_DOOD_FAILED: 'Failed to remove DOOD role from account',
  ACCOUNT_REMOVE_DOOD_SUCCESS: 'Successfully removed DOOD role from account',
  RESOURCE_METADATA_CREATE_SUCCESS: 'Resource Metadata creation successful',
  RESOURCE_METADATA_UPDATE_SUCCESS: 'Resource Metadata update successful',
  HUMAN_METADATA_CREATE_SUCCESS: 'Human Metadata creation successful',
  HUMAN_METADATA_UPDATE_SUCCESS: 'Human Metadata update successful',
  AVAILABILITY_CREATE_SUCCESS: `Availability creation successful`,
  AVAILABILITY_UPDATE_SUCCESS: `Availability update successful`,
  AVAILABILITY_DELETE_SUCCESS: `Avaialbility deletion successful`,
  BAR_TEMPLATE_CREATE_SUCCESS: 'New bar template creation successful',
  BAR_TEMPLATE_DELETE: (name) => `Bar template "${name}" deletion successful`,
  BAR_TEMPLATE_UPDATE: (name) => `Bar template "${name}" update successful`,
  BAR_PERIOD_TEMPLATE_CREATE_SUCCESS: 'New bar period template creation successful',
  BAR_PERIOD_TEMPLATE_DELETE: (name) => `Bar period template "${name}" deletion successful`,
  BAR_PERIOD_TEMPLATE_UPDATE: (name) => `Bar period template "${name}" update successful`,
  BAR_INSTANCE_CREATE_SUCCESS: `Bar instance create successful`,
  BAR_INSTANCE_UPDATE_SUCCESS: `Bar instance update successful`,
  BAR_INSTANCE_DELETE_SUCCESS: `Bar instance deletion successful`,
  BAR_PERIOD_INSTANCE_CREATE_SUCCESS: `Bar period instance create successful`,
  BAR_PERIOD_INSTANCE_UPDATE_SUCCESS: `Bar period instance update successful`,
  BAR_PERIOD_INSTANCE_DELETE_SUCCESS: `Bar period instance deletion successful`,

  CANCELLATION_REASON_CREATED: `Cancellation Reason creation successful`,
  CANCELLATION_REASON_DELETED: `Cancellation Reason deletion successful`,
  CANCELLATION_REASON_UPDATED: `Cancellation Reason update successful`,
  CANCELLATION_SUB_REASON_CREATED: `Cancellation Sub-Reason creation successful`,
  CANCELLATION_SUB_REASON_DELETED: `Cancellation Sub-Reason deletion successful`,
  CANCELLATION_SUB_REASON_UPDATED: `Cancellation Sub-Reason update successful`,

  FLYPRO_GROUP_CREATED: `Flypro Group creation successful`,
  FLYPRO_GROUP_DELETED: `Flypro Group deletion successful`,
  FLYPRO_GROUP_UPDATED: `Flypro Group update successful`,

  METRIC_TYPE_CREATED: `Metric Type creation successful`,
  METRIC_TYPE_DELETED: `Metric Type deletion successful`,
  METRIC_TYPE_UPDATED: `Metric Type update successful`,

  CHANGE_LESSON_STATUS_SUCCESS: (lessonName, status) => `Change ${lessonName} status to ${status} successfully`,
  CAT_COHORT_CREATE_SUCCESS: 'New CAT cohort creation successful',
  CAT_COHORT_DELETE_SUCCESS: 'CAT cohort deletion successful',
  CAT_COHORT_UPDATE_SUCCESS: 'CAT cohort update successful',
  CAT_COHORT_ENROLMENT_DELETE_SUCCESS: 'CAT cohort enrolment deletion successful',
  CAT_COHORT_ENROLMENT_UPDATE_SUCCESS: 'CAT cohort enrolment update successful',
  CAT_LESSON_UPDATE_SUCCESS: 'CAT activity update successful',
  CAT_RESOURCE_UPDATE_SUCCESS: 'CAT resource update successful',
  CAT_SCHOOL_UPDATE_SUCCESS: 'CAT school update successful',
  CAT_SCHOOL_WEATHER_UPDATE_SUCCESS: 'CAT school weather update successful',
  CAT_SCHOOL_SYLLABUS_UPDATE_SUCCESS: 'CAT school activity set update successful',
  CHANGE_STUDENT_LESSON_STATUS_ERROR: 'Student activity status change failed.',
  CLEAR_FUTURE_SCHEDULE_ERROR: 'Schedule deletion failed',
  CLEAR_FUTURE_SCHEDULE_SUCCESS: (startDate, endDate) => `Schedule from ${startDate} to ${endDate} deletion successful`,
  COHORT_CREATE_SUCCESS: 'New cohort creation successful',
  COHORT_DELETE_SUCCESS: (name) => `Cohort "${name}" deletion successful`,
  COHORT_DELETE_ERROR: (name) => `Cohort "${name}" deletion successful`,
  COHORT_DUPLICATE_SUCCESS: (oldCohort, newCohort) => `Duplicate "${oldCohort}" to "${newCohort}" successfully`,
  COHORT_NOT_FOUND: 'Cohort not found',

  CREATE_BRIEF_ERROR: 'Brief creation failed',
  CREATE_BRIEF_SUCCESS: 'Brief creation successful',

  CREATE_EVENT_ERROR: 'Event creation failed',
  CREATE_EVENT_SUCCESS: 'Event creation successful',

  CREATE_ENROLMENT_SUCCESS: 'Enrolment creation successful',
  CREATE_ENROLMENT_ERROR: 'Event creation failed',

  CREATE_STUDENT_FAILED: 'New student creation failed',
  CREATE_STUDENT_SUCCESS: 'New student creation successful',

  CURRENCY_EVENT_CREATED: (name) => `Currency event "${name}" creation successful`,
  CURRENCY_EVENT_DELETED: (name) => `Currency event "${name}" deletion successful`,
  CURRENCY_EVENT_UPDATED: (name) => `Currency event "${name}" update successful`,
  CURRENCY_OVERRIDE_CREATED: 'Currency override creation successful',
  CURRENCY_OVERRIDE_DELETED: 'Currency override deletion successful',
  CURRENCY_OVERRIDE_UPDATED: 'Currency override update successful',
  DAILY_SAR_CREATE_SUCCESS: 'Daily SAR creation successful',
  DAILY_SAR_DELETE_SUCCESS: 'Daily SAR deletion successful',
  DAILY_SAR_UPDATE_SUCCESS: 'Daily SAR update successful',
  DAILY_BAR_INSTANCE_CREATE_SUCCESS: 'Daily Bar Instance creation successful',
  DAILY_BAR_INSTANCE_DELETE_SUCCESS: 'Daily Bar Instance deletion successful',
  DAILY_BAR_INSTANCE_UPDATE_SUCCESS: 'Daily Bar Instance update successful',
  SCENARIO_CREATED: (name) => `Scenario "${name}" creation successful`,
  SCENARIO_ROLLED_BACK: (name) => `Scenario "${name}" roll back successful`,
  DATASET_CREATED: (name) => `Default dataset "${name}" creation successful`,
  DATASET_DELETED: (name) => `Scenario "${name}" deletion successful`,
  DEFAULT_DATASET_DELETED: (name) => `Default dataset "${name}" deletion successful`,
  DATASET_ROLLED_BACK: (name) => `Default dataset "${name}" roll back successful`,
  DATASET_UPDATED: (name) => `Scenario "${name}" update successful`,
  DEFAULT_DATASET_UPDATED: (name) => `Default dataset "${name}" update successful`,
  DATASET_DELETE_SUCCESS: (datasetName) => `Dataset "${datasetName}" deletion success`,
  DEFAULT_DATASET_UPLOAD_SUCCESS: (defaultDatasetName) => `Default dataset "${defaultDatasetName}" upload success`,
  DATASET_FILE_CREATED_SUCCESS: (datasetName) => `Spreadsheet for dataset "${datasetName}" can now be downloaded`,
  DATASET_BACKUP_CREATED_SUCCESS: (datasetName) => `Backup for dataset "${datasetName}" can now be downloaded`,
  DEFAULT_DATASET_UPLOAD_ERROR: (datasetName) => `Upload for dataset "${datasetName}" failed`,
  DATASET_FILE_CREATED_ERROR: (datasetName) => `Spreadsheet creation for dataset "${datasetName}" failed`,
  DATASET_BACKUP_CREATED_ERROR: (datasetName) => `Backup creation for dataset "${datasetName}" failed`,
  DATASET_FILE_CREATED_STARTED: (datasetName) =>
    `Spreadsheet creation for dataset "${datasetName}" started successfully`,
  DEFAULT_DATASET_NAME_ERROR: (defaultDatasetName) =>
    `A deleted default dataset with the name "${defaultDatasetName}"  already exists.`,
  DELETE_ALL_OLD_DATASETS_SUCCESS: 'All old datasets deletion successful',
  DELETE_BRIEF_ERROR: 'Brief deletion failed',
  DELETE_BRIEF_SUCCESS: 'Brief deletion success',
  DELETE_EVENT_ERROR: 'Event deletion error',
  DELETE_EVENT_SUCCESS: 'Event deletion successful',
  DELETE_PURGE_EVENTS_SUCCESS: 'Deleted events deletion successful',
  DELETE_ENROLMENT_ERROR: 'Enrolment deletion error',
  DELETE_ENROLMENT_SUCCESS: 'Enrolment deletion successful',
  DELETE_STUDENT_FAILED: (name) => `Student "${name}" deletion failed`,
  DELETE_STUDENT_PROGRESS_ERROR: 'Student progress change failed.',
  DELETE_STUDENT_SUCCESS: (name) => `Student "${name}" deletion successful`,
  DOUBLE_BUBBLE_LESSON_ASSIGN: (lessonName, pool) => `Assign activity ${lessonName} to pool ${pool} successful`,
  DOUBLE_BUBBLE_LESSON_DELETE: (lessonName, pool) => `Delete
  activity
  ${lessonName}
  from
  pool
  ${pool}
  successful`,
  DUTY_TEMPLATE_CREATE_SUCCESS: 'New duty template creation successful',
  DUTY_TEMPLATE_DELETE: (name) => `Duty template ${name} deletion successful`,
  DUTY_TEMPLATE_UPDATE_SUCCESS: 'Duty template update successful',
  ENGINE_JOB_CANCEL_SUCCESS: 'Engine job canceled successfully',
  ENGINE_JOB_CANCEL_ERROR: 'Engine job cancel failed',
  ENGINE_JOB_DELETE_SUCCESS: 'Engine job deleted successfully',
  ENGINE_JOB_DELETE_ERROR: 'Engine job deletion failed',
  EXPORT_DATASET_BACKUP_SUCCESS: 'Export scenario backup successful',
  FETCH_HUMANS_ERROR: 'Personnel fetch failed',
  FETCH_GRADUATES_ERROR: 'Graduated Students fetch failed',
  FETCH_INACTIVE_STUDENTS_ERROR: 'Inactive Students fetch failed',
  FETCH_NOT_COMPLETED_ERROR: 'Not Completed Students fetch failed',
  FETCH_STUDENT_DETAIL_ERROR: 'Student progress detail fetch failed.',
  FETCH_STUDENTS_ERROR: 'Students fetch failed',

  FLIGHT_CREATE_SUCCESS: 'New flight creation successful',
  FLIGHT_DELETE_SUCCESS: (name) => `Flight "${name}" deletion successful`,

  FORM_ERROR: 'You have errors in the form.',
  GLOBAL_SAR_CREATE_SUCCESS: 'New global SAR creation successful',
  GLOBAL_SAR_DELETE_SUCCESS: 'Global SAR deletion successful',
  GLOBAL_SAR_DELETE_WARNING: 'Global SAR cannot be deleted here. Please go to SAR configuration page.',
  GLOBAL_SAR_UPDATE_SUCCESS: 'Global SAR update successful',
  GROUP_CREATE_SUCCESS: 'New group creation successful',
  GROUP_DELETE_SUCCESS: (name) => `Group "${name}" deletion successful`,
  GROUP_ENTITY_CREATE_SUCCESS: 'New Personnel has added to the group successfully',
  GROUP_ENTITY_DELETE_SUCCESS: (name) => `Personnel "${name}" has been removed from group successfully`,
  ASSIGN_SCHOOL_AVAILABILITY_SUCCESS: `School availability add successful`,
  REMOVE_SCHOOL_AVAILABILITY_SUCCESS: `School availability removed successful`,
  HUMAN_CREATE_SUCCESS: `Personnel creation successful`,
  HUMAN_DELETE_SUCCESS: (name) => `Personnel "${name}" deletion successful`,
  HUMAN_UPDATE_SUCCESS: (name) => `Personnel "${name}" update successful`,
  HUMAN_TAG_CREATED: (name) => `Personnel Tag "${name}" creation successful`,
  HUMAN_NOT_FOUND: 'Personnel not found',
  HUMAN_TAG_UPDATED: (name) => `Personnel Tag "${name}" update successful`,
  HUMAN_TAG_DELETED: (name) => `Personnel Tag "${name}" deletion successful`,
  LESSON_CREATED: (name) => `Activity "${name}" creation successful`,
  LESSON_DELETED: (name) => `Activity "${name}" deletion successful`,
  LESSON_DUPLICATED: (name) => `Activity "${name}" duplicate successful`,
  LESSON_GUIDE_DELETED: (name) => `Activity guide "${name}" deletion successful`,
  LESSON_GUIDE_UPLOADED: 'Activity guide upload successful',
  LESSON_INELIGIBLE_CREATED: (name) => `Ineligible Activity "${name}" creation successful`,
  LESSON_INELIGIBLE_DELETED: (name) => `Ineligible Activity "${name}" deletion successful`,
  LESSON_MODULE_CREATED: (moduleNumber) => `Activity module ${moduleNumber} creation successful`,
  LESSON_MODULE_DELETED: (moduleNumber) => `Activity module ${moduleNumber} deletion successful`,
  LESSON_MODULE_UPDATED: 'Activity module update successful',
  LESSON_UPDATED: (name) => `Activity "${name}" update successful`,
  LESSON_EVENT_PHASE_DELETE_ERROR: 'Cannot delete Event phase as the Activity needs to have an Event phase',
  LESSON_EVENT_PHASE_UPDATE_ERROR: 'Cannot update Event phase name as the Activity needs to have an Event phase',
  LESSON_PHASE_DELETE_SUCCESS: (phaseName) => `"${phaseName}" activity phase deleted`,
  LESSON_PHASE_REQUIREMENT_CREATED: `Activity Phase Requirement creation successful`,
  LESSON_PHASE_REQUIREMENT_DELETED: (name) => `Activity Phase Requirement "${name}" deletion successful`,
  LESSON_PHASE_REQUIREMENT_DELETE_DISABLED: `You can't delete a requirement which has resources attached to it`,
  LESSON_PHASE_REQUIREMENT_UPDATED: (name) => `Activity Phase Requirement "${name}" update successful`,
  LESSON_PHASE_RESOURCE_DELETED: `Activity Phase Ressource deletion successful`,
  LESSON_VERSION_PROMOTED_AS_CURRENT: (versionNO) => `Version "${versionNO}" promoted as current version`,
  LESSON_VERSION_CREATE_SUCCESS: (versionNO) => `A new version created from version "${versionNO}"`,
  LESSON_VERSION_SOFT_DELETE_SUCCESS: (versionNO) => `Version "${versionNO}" deletion successful`,
  LESSON_VERSION_HARD_DELETE_SUCCESS: (versionNO) => `Version "${versionNO}" purge successful`,
  LESSON_VERSION_RESTORE_SUCCESS: (versionNO) => `Version "${versionNO}" restore successful`,
  LESSON_HARD_DELETE_SUCCESS: `Activity purge successful`,
  LESSON_RESTORE_SUCCESS: (name) => `Activity ""${name} restore successful`,
  ACTIVITY_REQUEST_CREATE_SUCCESS: `Activity Request creation successful`,
  ACTIVITY_REQUEST_CREATE_ERROR: `Activity Request creation failed`,
  ACTIVITY_REQUEST_DELETE_SUCCESS: `Activity Request deletion successful`,
  ACTIVITY_REQUEST_DELETE_ERROR: `Activity Request deletion failed`,
  OLD_DATASET_DELETE_SUCCESS: (datasetName) => `Old dataset "${datasetName}" deletion success`,
  MAX_BURDEN_UPDATED: 'Max burden update successful',
  PRIORITIES_CREATE: 'Priorities creation successful',
  PRIORITIES_UPDATE: 'Priorities update successful',
  QUALIFICATION_CREATED: (name) => `Qualification "${name}" creation successful`,
  QUALIFICATION_DELETED: (name) => `Qualification "${name}" deletion successful`,
  QUALIFICATION_UPDATED: 'Qualification update successful',
  QUALIFICATION_GROUP_CREATED: 'New qualification group creation successful',
  QUALIFICATION_TYPE_CREATED: 'New qualification type creation successful',
  QUALIFICATION_TYPE_UPDATED: (name) => `Qualification Type "${name}" update successful`,
  QUALIFICATION_GROUP_DELETED: 'Qualification group deletion successful',
  QUALIFICATION_TYPE_DELETED: 'Qualification type deletion successful',
  QUALIFICATION_TYPE_DELETE_DISABLED: `You can't delete a qualification type which has qualifications attached to it`,
  QUALIFICATION_GROUP_UPDATED: (name) => `Qualification group "${name}" update successful`,
  QUALIFICATION_GROUP_DELETE_DISABLED: `You can't delete a qualification group which has qualifications attached to it`,
  QUALIFICATION_IN_GROUP_ADDED: 'Qualification added to group successful',
  QUALIFICATION_IN_GROUP_REMOVE: 'Qualification removed from group successful',
  RELABEL_EVENTS_SUCCESS: 'Assign event designator successful',
  CONFIG_CREATED: 'Resource Config create successful',
  CONFIG_UPDATED: 'Resource Config update successful',
  CONFIG_DELETED: (name) => `Resource Config "${name}" deletion successful`,
  CONFIG_TYPE_CREATED: 'Resource Config Type create successful',
  CONFIG_TYPE_UPDATED: (name) => `Resource Config Type  "${name}" update successful`,
  CONFIG_TYPE_DELETED: 'Resource Config Type deletion successful',
  CONFIG_TYPE_DELETE_DISABLED: `You can't delete a resource config type which has configs attached to it`,
  CONFIG_GROUP_CREATED: 'New config group creation successful',
  CONFIG_GROUP_UPDATED: (name) => `Resource Config group "${name}" update successful`,
  CONFIG_GROUP_DELETE_DISABLED: `You can't delete a resource config group which has configs attached to it`,
  CONFIG_GROUP_DELETED: (name) => `Resource Config Group "${name}" deletion successful`,
  CONFIG_IN_GROUP_ADDED: 'Resource Config added to group successful',
  CONFIG_IN_GROUP_REMOVE: 'Resource Config removed from group successful',
  RESOURCE_CLONE_SUCCESS: (resourceType, name) => `${resourceType} "${name}" clone successful`,
  RESOURCE_CREATED: (name) => `Resource "${name}" creation successful`,
  RESOURCE_DELETED: (name) => `Resource "${name}" deletion successful`,
  RESOURCE_TYPE_CREATED: (name) => `Resource type "${name}" creation successful`,
  RESOURCE_TYPE_DELETED: (name) => `Resource type "${name}" deletion successful`,
  RESOURCE_TYPE_UPDATED: (name) => `Resource type "${name}" update successful`,
  RESOURCE_UPDATED: (name) => `Resource "${name}" update successful`,
  RESOURCE_NOT_FOUND: 'Resource not found',
  RESOURCE_TYPE_NOT_FOUND: 'Resource type not found',
  RESTORE_DATASET_FROM_BACKUP_SUCCESS: 'Restore scenario successful',
  RESTORE_DATASET_SUCCESS: (datasetName) => `Dataset "${datasetName}" restore successful`,
  SAVE_SUCCESS: 'Saved.',
  SCHOOL_NOT_FOUND: 'School not found',
  SCHEDULE_EVENT_LOCK_SUCCESS: 'Lock event successful',
  SCHEDULED_EVENT_UNLOCK_SUCCESS: 'Unlock event successful',
  YOU_ARE_DOOD_ALREADY: 'You are already assigned as the DOOD',
  SET_DOOD_SUCCESS: 'You have been assigned as the DOOD successfully',
  SET_DOOD_ERROR: 'Assigning you as the DOOD failed',
  UPDATE_DAILY_STATUS_SUCCESS: 'Update daily status successful',
  SET_FLYPRO_PLANNED_SUCCESS: 'Set flypro as planned successful',
  SET_FLYPRO_PUBLISHED_SUCCESS: 'Set flypro as published successful',
  SET_FLYPRO_DRAFT_SUCCESS: 'Set flypro as draft successful',
  SHARED_LESSON_ADD_SUCCESS: 'Shared activity created successful',
  SHARED_LESSON_REMOVE_SUCCESS: 'Shared activity removal successful',
  STICKY_NOTE_CREATED: 'New sticky note creation successful',
  STICKY_NOTE_UPDATED: 'Sticky note update successful',
  STICKY_NOTE_DELETED: 'Sticky note deletion successful',
  STICKY_NOTE_TEMPLATE_CREATED: 'New sticky note template creation successful',
  STICKY_NOTE_TEMPLATE_DELETED: 'Sticky note template deletion successful',
  STICKY_NOTE_TEMPLATE_UPDATED: 'Sticky note template update successful',
  STUDENT_TRACKER_PROGRESS_RESULT_UPDATED: (lessonName) => `Activity ${lessonName} result update successful`,
  STUDENT_TYPE_CREATED: 'New student type creation successful',
  SWITCH_RESOURCE_SUCCESS: 'Switch resource successful',
  SWITCH_RESOURCE_ERROR: 'Switch resource failed because the event is in past ',
  SYLLABUS_CREATED: (name) => `Activity Set "${name}" creation successful`,
  SYLLABUS_CLONED: (name) => `Activity Set "${name}" clone successful`,
  SYLLABUS_DELETED: (name) => `Activity Set "${name}" deletion successful`,
  SYLLABUS_UPDATED: (name) => `Activity Set "${name}" update successful`,
  SYLLABUS_NOT_FOUND: 'Activity Set not found',
  SCENARIO_NOT_FOUND: 'Scenario not found',
  LESSON_NOT_FOUND: 'Activity not found',
  LESSON_PHASE_NOT_FOUND: 'Activity phase not found',
  FLIGHT_NOT_FOUND: 'Flight not found',
  GROUP_NOT_FOUND: 'Group not found',
  TERMINATE_ALL_ENGINE_JOBS: 'Cancelled all engine jobs successfully',
  DELETE_ALL_ENGINE_JOBS: 'All engine jobs deleted successfully',
  TMUFF_CREATE_SUCCESS: 'TMUFF creation successful',
  TMUFF_DELETE_SUCCESS: 'TMUFF deletion successful',
  TMUFF_UPDATE_SUCCESS: 'TMUFF update successful',
  TRAINING_FACILITY_UPDATED: (name) => `Training facility ${name} update successful`,
  UNAVAILABILITY_CREATE_SUCCESS: `Unavailability creation successful`,
  UNAVAILABILITY_DELETE_SUCCESS: `Unavailability deletion successful`,
  UNAVAILABILITY_UPDATE_SUCCESS: `Unavailability update successful`,
  UNAVAILABILITY_TYPE_CREATE_SUCCESS: `Unavailability type creation successful`,
  UNAVAILABILITY_TYPE_DELETE_SUCCESS: `Unavailability type deletion successful`,
  UNAVAILABILITY_TYPE_UPDATE_SUCCESS: `Unavailability type update successful`,
  UPDATE_BRIEF_ERROR: 'Brief update failed',
  UPDATE_BRIEF_SUCCESS: 'Brief update successful',
  UPDATE_COHORT_PRIORITY_SUCCESS: 'Cohort priority update successful',
  UPDATE_ENROLMENT_PRIORITY_SUCCESS: 'Enrolment priority update successful',
  UPDATE_EVENT_ERROR: 'Event update failed',
  UPDATE_EVENT_SUCCESS: 'Event update successful',

  UPDATE_ENROLMENT_PROGRESS_STATUS_SUCCESS: 'Enrolment progress status update successful',
  UPDATE_ENROLMENT_SUCCESS: 'Enrolment update successful',
  UPDATE_ENROLMENT_ERROR: 'Event update failed',

  UPDATE_FCF_EVENT_ERROR: 'FCF/GR event update failed',
  UPDATE_FCF_EVENT_SUCCESS: 'FCF/GR event update successful',
  UPDATE_FLY_EVENT_ERROR: 'Event update failed',
  UPDATE_FLY_EVENT_SUCCESS: 'Event update successful',
  UPDATE_GROUND_EVENT_ERROR: 'Ground event update failed',
  UPDATE_GROUND_EVENT_SUCCESS: 'Ground event update successful',
  UPDATE_PAST_EVENT_WARNING: 'Any changes to past events will not alter enrolment progress records',
  UPDATE_SIM_EVENT_ERROR: 'Simulator event update failed',
  UPDATE_SIM_EVENT_SUCCESS: 'Simulator event update successful',
  UPDATE_STUDENT_TRACKER_STUDENT_ERROR: 'Student detail update failed',
  UPDATE_STUDENT_TRACKER_STUDENT_SUCCESS: 'Student detail update successful',
  UPDATE_PAST_EVENTS_STATUS_SUCCESS:
    'Event update process started, this may take some time, refresh after a while to see changes.',
  UPLOAD_PEX_FILE_FAILED: 'PEX file upload failed',
  VERSION_PUBLISH: (versionName) => `New version ${versionName} publish successful`,
};

export const CONFIRM_MESSAGES = {
  ACCEPT_TEMP_SCENARIO:
    'This (or part of this plan) is system generated (Auto Planned). Rejecting this plan will delete auto-planned bookings.',
  CHANGE_REMEDIAL_LESSON_AS_COMPLETED: (lessonName) => `Are you sure to change ${lessonName}'s status as COMPLETED?`,
  DELETE_ALL: 'Are you sure to delete all old datasets?',
  DELETE_AVAILABILITY: 'Are you sure to delete this availability?',
  DELETE_BAR_TEMPLATE: (name) => `Are you sure to delete bar template "${name}"?`,
  DELETE_BAR_PERIOD_TEMPLATE: (name) => `Are you sure to delete bar period template "${name}"?`,
  DELETE_BAR_INSTANCE: `Are you sure to delete the bar?`,
  DELETE_BAR_PERIOD_INSTANCE: `Are you sure to delete the bar period?`,
  DELETE_BRIEF_CONFIRMATION: (name) => `Are you sure to delete brief "${name}"?`,
  DELETE_BRIEF_FROM_SQUADRON: (squadron) => `Are you sure you want to delete this brief from ${squadron}?`,
  DELETE_CANCELLATION_REASON: `Are you sure you want to delete the cancellation reason?`,
  DELETE_CANCELLATION_SUB_REASON: `Are you sure you want to delete the cancellation sub-reason?`,
  DELETE_CAT_COHORT: `Are you sure you want to delete the cat cohort?`,
  DELETE_CAT_COHORT_ENROLMENT: `Are you sure you want to delete the cat cohort enrolment?`,
  DELETE_METRIC_TYPE: `Are you sure you want to delete the metric type?`,
  DELETE_COHORT_FROM_SQUADRON: (cohortName, squadronName) =>
    `Are you sure you want to remove this cohort "${cohortName}" from "${squadronName}"?`,
  DELETE_DAILY_SAR: 'Are you sure to delete this daily SAR?',
  DELETE_DATASET: (datasetName) => `Are you sure to delete dataset "${datasetName}"?`,
  DELETE_DUTY_TEMPLATE: (name) => `Are you sure to delete duty template "${name}"?`,
  DELETE_EVENT_CONFIRMATION: (name) => `Are you sure to delete activity "${name}"?`,
  DELETE_EVENTS: `Are you sure you want to permanently delete all deleted events?`,
  DELETE_ENROLMENT: `Are you sure to delete the enrolment?`,
  DELETE_FLYPRO_GROUP: `Are you sure to delete the flypro group?`,
  DELETE_HUMAN: (name) => `Are you sure to delete personnel "${name}"?`,
  DELETE_HUMAN_TAGS: (name) => `Are you sure to delete personnel tag "${name}"?`,
  DELETE_GROUP: (name) => `Are you sure to delete group "${name}"?`,
  DELETE_GLOBAL_SAR: 'Are you sure to delete this SAR?',

  DELETE_SOFT_LESSON_VERSION: (versionNO) => `Are you sure to delete activity version "${versionNO}"?`,
  DELETE_HARD_LESSON_VERSION: (versionNO) =>
    `Are you sure to purge activity version "${versionNO}"? If purged, the version can not be restored and will be completely deleted from the system!`,
  DELETE_HARD_LESSON: `Are you sure to purge this activity? If purged, the activity can not be restored and will be completely deleted from the system!`,
  DELETE_LESSON_GUIDE: (guideName) => `Are you sure to delete activity guide "${guideName}"?`,
  DELETE_LESSON_PHASE: (phase) => `Are you sure to delete phase "${getMaskedPhaseName(phase)}"?`,
  DELETE_LESSON_PHASE_REQUIREMENT: (requirementName) =>
    `Are you sure to delete activity phase requirement ${requirementName}? `,
  DELETE_LESSON_PHASE_RESOURCE_HUMAN: `Are you sure to delete activity phase resource? `,
  DELETE_LESSON_MODULE: (moduleNumber) =>
    `Are you sure to delete Module ${moduleNumber}? This action might be unsuccessful if there are any lessons in this module.`,
  DELETE_ACTIVITY_REQUEST: 'Are you sure to delete activity version?',
  DELETE_OLD_DATASET: (datasetName) => `Are you sure to delete old dataset "${datasetName}"?`,
  DELETE_QUALIFICATION: (name) => `Are you sure you want to delete qualification ${name}?`,
  DELETE_QUALIFICATION_FROM_GROUP: (qualification, group) =>
    `Are you sure you want to delete ${qualification} from group ${group}?`,
  DELETE_QUALIFICATION_GROUP: (group) => `Are you sure you want to delete group ${group}?`,
  DELETE_QUALIFICATION_TYPE: (type) => `Are you sure you want to delete type ${type}?`,

  DELETE_CONFIG: (name) => `Are you sure you want to delete config ${name}?`,
  DELETE_CONFIG_TYPE: (name) => `Are you sure you want to delete config type ${name}?`,
  DELETE_CONFIG_GROUP: (name) => `Are you sure you want to delete config group ${name}?`,
  DELETE_CONFIG_FROM_GROUP: (config, group) => `Are you sure you want to delete ${config} from group - ${group}?`,

  DELETE_RESOURCE: (resource) => `Are you sure you want to permanently delete the resource *${resource}?*`,
  DELETE_RESOURCE_FROM_SQUADRON: (resourceName, squadronName) =>
    `Are you sure you want to remove this resource "${resourceName}" from "${squadronName}"?`,
  DELETE_RESOURCE_TYPE: (resourceType) =>
    `Are you sure you want to permanently delete the resource type *${resourceType}*?`,
  DELETE_STICKY_NOTE: 'Are you sure you want to delete this sticky note?',
  DELETE_STICKY_NOTE_TEMPLATE: 'Are you sure you want to delete this sticky note template?',
  DELETE_STUDENT: (studentPEXId) => `Are you sure you want to permanently delete the student ${studentPEXId}?`,
  DELETE_STUDENT_FROM_LESSON: (studentName, lessonName) =>
    `Are you sure to delete student "${studentName}" from activity "${lessonName}"?`,
  DELETE_STUDENT_REMEDIAL_LESSON: (lessonName, studentName) =>
    `Are you sure to delete remedial activity "${lessonName}" from student "${studentName}"?`,
  DELETE_TMUFF: 'Are you sure to delete this TMUFF?',
  DELETE_UNAVAILABILITY: 'Are you sure to delete this unavailability?',
  DELETE_UNAVAILABILITY_TYPE: (name) => `Are you sure you want to permanently delete unavailability type ${name}?`,
  DELETE_USER: (username) => `Are you sure to delete user "${username}" ?`,
  DRAG_DROP_BACKUP_FILE: 'Drag and drop backup file here, or click to select file',
  DRAG_DROP_DEFAULT_DATASET: 'Drag and drop default dataset xlsx file here, or click to select file',
  DRAG_DROP_FILE: 'Drag and drop PEX file here, or click to select file',
  DRAG_DROP_LESSON_GUIDE: 'Drag and drop activity guide file here, or click to select file',
  EXPORT_SCENARIO_BACKUP:
    'Backing up this scenario will clear any simulation outputs in this scenario (these can be re-generated by running a new simulation job). Are you sure?',
  MARK_DOOD: (user) =>
    `Are you sure you want to set this user "${user}" as "DOOD"? This action will also unset "DOOD" role for any other users.`,
  RESTORE_DELETED_EVENT: (eventName) => `Are you sure to restore "${eventName}"?`,
  RELABEL_SORTIE_NUMBER: 'Are you sure you want to re-designate all events for this day?',
  REMOVE_COURSE_MANAGER: "Are you sure you want to remove this Course Manager's PMKeyS from this Cohort?",
  REMOVE_GROUP_HUMAN: (name) => `Are you sure you want to remove "${name}" from this group?`,
  REMOVE_FLIGHT_MANAGER: "Are you sure you want to remove this FLOPSO's PMKeyS from this Flight?",
  REMOVE_FLIGHT_HUMAN: 'Are you sure you want to remove this Member from this Flight?',
  REMOVE_FLIGHT_RESOURCE: 'Are you sure you want to remove this Resource from this Flight?',
  RESET_STUDENT_LESSON_STATUS: (name) =>
    `Reset Status - Are you sure you want to reset the status of activity ${name} to To Be Completed?`,
  EXEMPT_STUDENT_LESSON_STATUS: (name) =>
    `Exempt Activity - Are you sure you want this student to skip activity ${name}?`,
  RESTORE_DATASET: (datasetName) => `Are you sure to restore dataset "${datasetName}"?`,
  PURGE_SIMULATION_RESULTS:
    'This dataset already has simulation results from a previous run. Running a new simulation will purge the existing results. Are you sure you want to continue?',
  CANCEL_ENGINE_JOB: 'Are you sure you want to cancel this engine job?',
  DELETE_ENGINE_JOB: 'Are you sure you want to delete this engine job? This action cannot be undone.',
  TERMINATE_ALL_ENGINE_JOBS:
    'Are you sure you want to reset the status of all engine jobs? WARNING: make sure no engine jobs are in working state, only use if jobs are stuck!',
  NO_ENGINE_JOBS_TO_CANCEL: 'No job to cancel. All engine jobs are already cancelled.',
  DELETE_ALL_ENGINE_JOBS: 'Are you sure you want to delete all engine jobs? This action cannot be undone.',
  NO_ENGINE_JOBS_TO_DELETE: 'No job to delete. All the jobs are deleted or in a state that can not be deleted',
  UNSET_DOOD: (user) =>
    `Are you sure you want to unset "DOOD" role for this user "${user}"? This action will reset the user to its previous role.`,
  UPDATE_PAST_EVENTS_STATUS:
    'This action will update the status of all "Planned" events in the past to "Completed". Are you sure to continue?',
  UPDATE_STUDENT_LESSON_STATUS: (name, status) => `Are you sure to change ${name}'s status as ${status}?`,
  VALIDATE_SCHEDULE: 'Start Validation will be started. It will takes about 1 - 2 minutes to finish',
};

export const MODAL_TITLES = {
  CHANGE_LESSON_STATUS: 'Change Activity Status',
  CHANGE_REMEDIAL_LESSON_AS_COMPLETED: 'Change Remedial Activity Status',
  DELETE_ALL: 'Delete All Old Datasets',
  DELETE_AVAILABILITY: 'Delete Availability',
  DELETE_BRIEF: 'Delete Brief',
  DELETE_BRIEF_FROM_SQUADRON: 'Delete Brief from Squadron',
  DELETE_CAT_COHORT: 'Delete Cat Cohort',
  DELETE_CAT_COHORT_ENROLMENT: 'Delete Cat Cohort Enrolment',
  DELETE_COHORT_FROM_SQUADRON: 'Remove Cohort From Squadron',
  DELETE_CANCELLATION_REASON: 'Delete Cancellation Reason',
  DELETE_CANCELLATION_SUB_REASON: 'Delete Cancellation Sub-Reason',
  DELETE_METRIC_TYPE: 'Delete Metric Type',
  DELETE_DAILY_SAR: 'Delete Daily SAR',
  DELETE_BAR_PERIOD_INSTANCE: 'Delete Bar Period',
  DELETE_DATASET: 'Delete Dataset',
  DELETE_EVENT: 'Delete Event',
  DELETE_EVENTS: 'Clear All Deleted Events',
  DELETE_ENROLMENT: 'Delete Enrolment',
  DELETE_FLYPRO_GROUP: 'Delete Flypro Group',
  DELETE_GROUP: 'Delete Group',
  DELETE_HUMAN: 'Delete Personnel',
  DELETE_HUMAN_TAGS: 'Delete Personnel Tag',
  DELETE_SOFT_LESSON_VERSION: 'Delete Activity Version',
  DELETE_HARD_LESSON_VERSION: 'Purge Activity Version',
  DELETE_HARD_LESSON: 'Purge Activity',
  DELETE_LESSON_PHASE: 'Delete Activity Phase',
  DELETE_LESSON_GUIDE: 'Delete Activity Guide',
  DELETE_LESSON_MODULE: 'Delete Activity Module',
  DELETE_LESSON_PHASE_REQUIREMENT: 'Delete Activity Phase Requirement',
  DELETE_LESSON_PHASE_RESOURCE_HUMAN: 'Delete Activity Phase Resource/Personnel',
  DELETE_ACTIVITY_REQUEST: 'Delete Activity Request',
  DELETE_OLD_DATSET: 'Delete Old Dataset',
  DELETE_QUALIFICATION_FROM_GROUP: 'Remove Qualification from Group',
  DELETE_QUALIFICATION: 'Delete Qualification',
  DELETE_QUALIFICATION_GROUP: 'Delete Qualification Group',
  DELETE_QUALIFICATION_TYPE: 'Delete Qualification Type',

  DELETE_CONFIG: 'Delete Resource Config',
  DELETE_CONFIG_FROM_GROUP: 'Remove Resource Config from Group',
  DELETE_CONFIG_GROUP: 'Delete Resource Config Group',
  DELETE_CONFIG_TYPE: 'Delete Resource Config Type',

  DELETE_RESOURCE_TYPE: 'Delete Resource Type',
  DELETE_RESOURCE: 'Delete Resource',
  DELETE_RESOURCE_FROM_SQUADRON: 'Remove Resource From Squadron',
  DELETE_STICKY_NOTE: 'Delete Sticky Note',
  DELETE_STICKY_NOTE_TEMPLATE: 'Delete Sticky Note Template',
  DELETE_STUDENT: 'Delete Student',
  DELETE_STUDENT_REMEDIAL_LESSON: 'Delete Remedial Activity',
  DELETE_TMUFF: 'Delete TMUFF',
  DELETE_UNAVAILABILITY: 'Delete Unavailability',
  DELETE_USER: 'Delete User',
  EXPORT_DATASET_BACKUP: 'Export Scenario Backup',
  MARK_DOOD: 'Set DOOD',
  UPDATE_PAST_EVENTS_STATUS: 'Update Past Events Status',
  RELABEL_SORTIE_NUMBER: 'Assign Event Designator',
  REMOVE_COURSE_MANAGER: "Remove Course Manager's PMKeyS from Cohort",
  REMOVE_GROUP_HUMAN: 'Remove Personnel from Group',
  REMOVE_FLIGHT_MANAGER: "Remove FLOPSO's PMKeyS from Flight",
  REMOVE_FLIGHT_HUMAN: 'Remove Personnel from Flight',
  REMOVE_FLIGHT_RESOURCE: 'Remove Resource from Flight',
  RESTORE_DATASET: 'Restore Dataset',
  RESTORE_DELETED_EVENT: 'Restore Deleted Event',
  PURGE_SIMULATION_RESULTS: 'Purge Previous Simulation Results',
  CANCEL_ENGINE_JOB: 'Cancel Engine Job',
  DELETE_ENGINE_JOB: 'Delete Engine Job',
  TERMINATE_ALL_ENGINE_JOBS: 'Cancel All Engine Jobs',
  DELETE_ALL_ENGINE_JOBS: 'Delete All Engine Jobs',
  TEMP_SCENARIO: 'Auto Planned Scenario',
  UNSET_DOOD: 'Unset DOOD',
  VALIDATE_SCHEDULE: 'Validate Schedule',
};

export const Simulation_Configurations = {
  ruleset_max_student_daily_study_hours: 'The maximum number of hours of training for a student in a day.',
  ruleset_max_student_daily_makespan_hours:
    'The maximum number of hours over which a student may undertake training each day.',
  ruleset_min_time_off_hours:
    'The minimum number of hours between finishing training one day and starting training the next day.',
  ruleset_max_training_events_per_regular_week:
    'The maximum number of training events personnel may be assigned to in a regular training week.',
  ruleset_max_training_events_per_short_week:
    'The maximum number of training events personnel can be assigned to in a short week (training week containing holidays or non-training days).',
  ruleset_max_flying_events_per_week:
    'The maximum number of flying events peronnel may be assigned to in a regular training week.',
  ruleset_min_hours_between_sim_and_flying_event:
    'The minimum number of hours a student must have between ending a simulator activity and starting a flying lesson.',
  ruleSet_remainingTrainingDaysToForceCurrencyEvents:
    'The number of training days remaining in the month before currency events are scheduled for instructors requiring additional hours to meet currency. Currency events are shceduled as a first priority before student lessons.',
  ruleSet_remainingTrainingDaysToInsertCurrencyEvents:
    'The number of training days remaining in the month before currency events are scheduled for instructors requiring additional hours to meet currency. Currency events are shceduled as a second priority after student lessons.',
  ruleset_shared_lesson_lookahead_count:
    'The number of lessons to look ahead for each student to find future shared activity opportunities.',
  execution_random_seed: 'The random seed from which the random stream is initialised.',
  ruleset_large_timestep_minutes:
    'The normal time step to advance when attempting to schedule a lesson. At 15 minutes lessons may start on the hour or 15, or 30 or 45 minutes after the hour.',
  ruleset_small_timestep_minutes:
    'A smaller time step to try to schedule lessons - activates if a activity has "use small time step" flag set to true.',
  flag_include_bad_weather_days: 'Flag to enable/disable random days affected by weather',
  flag_include_random_days_off: 'Flag to enable/disable random days off for students and personnel',
  flag_include_currency_events: 'Flag to exclude/include instructors and staff from events if their currency lapses.',
  flag_double_bubble: 'Flag to allow the engine to create events with shared resources and offset event phases.',
  flag_double_down:
    'Flag to allow students who have completed a activity to partner with another student if no other partner is available.',
  flag_align_resources:
    'Flag to enable/disable the aligning of pairs of resources with the same numeric extension in their names.',
  flag_use_student_burden: 'Delay starting new students if school is at max training burden',
  flag_override_priority: 'Allow engine to schedule high priority students and cohorts first',
  flag_autofill_events_all: 'Allow engine to auto fill all events',
  flag_autofill_events_only_unlocked: 'Allow engine to auto fill unlocked events only',
  flag_no_auto_fill: 'Flag to enable/disable auto fill events',
  strategy_type: 'The schedule acceptance strategy to be used',
  // prioritisation_student: 'Student prioritisation strategy',
  // prioritisation_studentType: 'Student type prioritisation strategy',
  prioritisation_cohort: 'Cohort prioritisation strategy',
  prioritisation_enrolment: 'Enrolment prioritisation strategy',
  prioritisation_human: 'Personnel prioritisation strategy',
  prioritisation_resource: 'Resource instance prioritisation strategy',
  prioritisation_resource_type: 'Resource type prioritisation strategy',
  prioritisation_lesson: 'Activity prioritisation strategy',
  prioritisation_period: 'The period for calculating and using a priority',
  strategy_shared_lesson_strategy_type: 'Shared activity algorithm to use',
  strategy_sample_count:
    "Number of samples ('n') to generate. Only used if the selected strategy requires a sample count.",
  execution_number_of_runs: 'Number of runs to conduct for statistical analysis',
  execution_thread_count: 'Number of threads to conduct the runs on',
  ruleset_student_illness_rate: 'The probability of a student being unexpectedly unavailable for a lesson.',
  ruleset_student_unable_to_fly_rate: 'The probability of a student being unfit to fly for a flying lesson.',
  ruleset_day_night_tolerance:
    ' The percentage of a "day in to night" event phase which must occur before (and after) last light.',
  strategy_generator_type: ' The schedule generation algorithm.',
};

export const SIMULATION_AUTO_FILL_OPTIONS = {
  ALL: 'ALL',
  NO_AUTOFILL: 'NONE',
  UNLOCKED_ONLY: 'UNLOCKED_ONLY',
};

export const SIMULATION_CONFIGURATION_FLAGS_EFFECTS = {
  auto_fill_method: {
    [SIMULATION_AUTO_FILL_OPTIONS.ALL]: 'Allow engine to auto fill all events',
    [SIMULATION_AUTO_FILL_OPTIONS.UNLOCKED_ONLY]: 'Allow engine to auto fill unlocked events only',
    [SIMULATION_AUTO_FILL_OPTIONS.NO_AUTOFILL]: 'Do not allow engine to auto fill any events',
  },
  flag_align_resources: {
    CHECKED: 'Enable the aligning of pairs of resources with the same numeric extension in their names',
    UNCHECKED: 'Disable the aligning of pairs of resources with the same numeric extension in their names',
  },
  flag_double_bubble: {
    CHECKED: 'Allow double bubble events in the schedule',
    UNCHECKED: 'Do not allow double bubble events in the schedule',
  },
  flag_double_down: {
    CHECKED:
      'Allow students who have passed a activity to resit a shared activity that would otherwise only have one student participating',
    UNCHECKED:
      'Do not allow students who have passed a activity to resit a shared activity that would otherwise only have one student participating',
  },
  flag_include_bad_weather_days: {
    CHECKED: 'Enable random days affected by weather',
    UNCHECKED: 'Disable random days affected by weather',
  },
  flag_include_currency_events: {
    CHECKED: 'Exclude instructors and staff from events if their currency lapses.',
    UNCHECKED: 'Include instructors and staff from events if their currency lapses.',
  },
  flag_include_random_days_off: {
    CHECKED: 'Enable random days off for personnel',
    UNCHECKED: 'Disable random days off for personnel',
  },
  flag_override_priority: {
    CHECKED: 'Allow engine to schedule high priority students and cohorts first',
    UNCHECKED: 'Do not allow engine to schedule high priority students and cohorts first',
  },
  flag_use_student_burden: {
    CHECKED: 'Delay starting new students if school is at max training burden',
    UNCHECKED: 'Do not delay starting new students if school is at max training burden',
  },
};

export const SIMULATION_CONFIGURATION_DROP_LIST_VALUES = {
  strategy_experiment_type: ['Daily', 'AverageOverNYearsWithMYearBuildUp'],
  strategy_generator_type: ['StudentCentricGenerator', 'TimeCentricGenerator'],
  strategy_type: ['GreedyGlideSlopeStrategy', 'GreedyBestOfNSamplesStrategy'],
  strategy_simulation_strategy_type: ['OneDayWithPassRates'],
  strategy_shared_lesson_strategy_type: ['WeightedPairs', 'WeightedPairsOverMultipleDays'],
  // prioritisation_student: ['ByGlideSlope', 'ByGlideSlopeWithHurriedExit', 'Equal', 'Random'],
  // prioritisation_studentType: ['ByGlideSlope', 'Equal', 'Random'],
  prioritisation_enrolment: ['ByGlideSlope', 'ByGlideSlopeWithHurriedExit', 'Equal', 'Random'],
  prioritisation_cohort: ['ByGlideSlope', 'Equal', 'Random'],
  prioritisation_human: ['ByMinutesUsed', 'ByAvailabilityOverPeriod', 'ByCurrency', 'Equal', 'Random'],
  prioritisation_resource: ['ByMinutesUsed', 'ByAvailabilityOverPeriod', 'ByCurrency', 'Equal', 'Random'],
  prioritisation_resource_type: ['ByAvailabilityOverPeriod', 'ByCurrency', 'Equal', 'Random'],
  prioritisation_lesson: [
    'ByResource',
    'ByClassSize',
    'ByUserPriorityValue',
    'ByAlgorithmPriorityValue',
    'Equal',
    'Random',
  ],
  prioritisation_period: ['Day', 'Week', 'Fortnight', 'Month', 'Quarter', 'Year', 'Never'],
};

export const SIMULATION_CONFIGURATION_DROP_DOWN_EFFECTS = {
  strategy_generator_type: {
    StudentCentricGenerator: 'Prioritises students, schedules as many lessons as possible for each student in turn.',
    TimeCentricGenerator:
      'Starts at the start of the day and schedules as many lessons at each possible starting time.',
  },
  strategy_type: {
    GreedyGlideSlopeStrategy: 'Create a single schedule and use it.',
    GreedyBestOfNSamplesStrategy:
      "Create 'n' schedules by randomising the primary prioritisation method, select the schedule that best reduces the collective glide slope. 'n' is defined by 'strategy.sample_count'.",
  },
  strategy_simulation_strategy_type: {
    OneDayWithPassRates: 'Day by day with pass rates. Any cancelled events will require a replan of the following day.',
  },
  strategy_shared_lesson_strategy_type: {
    WeightedPairs:
      'Use weighted pairs to decide who is best suited to be paired up for a shared lesson. Create fresh weighted pairs each day.',
    WeightedPairsOverMultipleDays:
      'Use weighted pairs to decide who is best suited to be paired up for a shared lesson. Use pairs from previous days if their activity is not yet scheduled.',
  },
  // prioritisation_student: {
  //   ByGlideSlope: 'Prioritise student based on how delayed they are in their expected training progress.',
  //   ByGlideSlopeWithHurriedExit: 'Prioritise student based on how delayed they are in their expected training progress with additional priority given to those within 1 month of completion.',
  //   Equal: 'All students are treated equally.',
  //   Random: 'Students are prioritised randomly.',
  // },
  // prioritisation_studentType: {
  //   ByGlideSlope: 'Prioritise a student type based on the collective delay in their expected training progress.',
  //   Equal: 'All student types are treated equally.',
  //   Random: 'Student types are prioritised randomly.',
  // },
  prioritisation_enrolment: {
    ByGlideSlope: 'Prioritise enrolments where progress is behind the expected glideslope curve.',
    ByGlideSlopeWithHurriedExit:
      'Prioritise enrolments where progress is behind the expected glideslope curve OR students are near completion.',
    Equal: 'Enrolments are treated equally.',
    Random: 'Enrolments are prioritised randomly.',
  },
  prioritisation_cohort: {
    ByGlideSlope: 'Prioritise cohorts where the sum of enrolments are behind their expected glideslope curve.',
    Equal: 'All cohorts are treated equally.',
    Random: 'Cohorts are prioritised randomly.',
  },
  prioritisation_human: {
    ByMinutesUsed: 'Prioritise personnel who have been occupied the least.',
    ByAvailabilityOverPeriod: 'Prioritise personnel who have the most availability.',
    ByCurrency: 'Prioritise personnel who have currency and are closest to expiry.',
    Equal: 'All personnel are treated equally.',
    Random: 'Personnel are prioritised randomly.',
  },
  prioritisation_resource: {
    ByMinutesUsed:
      'Prioritise resources by the number of minutes used to date. Less usage would be placed in higher priority.',
    ByAvailabilityOverPeriod:
      "Prioritise resources by their availability over the period defined by 'p_period'. A resource with limited availability has higher priority.",
    ByCurrency:
      'Prioritise resources which have to meet currency. Additionally resources farthest from meeting currency have highest priority.',
    Equal: 'All resources are treated equally.',
    Random: 'Resources are prioritised randomly.',
  },
  prioritisation_resource_type: {
    ByAvailabilityOverPeriod:
      "Prioritise resource types by their availability over the period defined by 'p_period'. A resource type with limited availability has higher priority.",
    ByCurrency:
      'Prioritise resource types which have to meet currency. Additionally resource types collectively farthest from meeting currency have highest priority.',
    Equal: 'All resource types are treated equally.',
    Random: 'Resource types are prioritised randomly.',
  },
  prioritisation_lesson: {
    ByResource: 'Prioritise lessons by the collective priority of the resources required.',
    ByClassSize: 'Prioritise lessons by the maximum possible class size. Higher class size results in higher priority.',
    ByUserPriorityValue:
      'Prioritise lessons by the activity priority value defined by the user in the activity details. A higher value indicates a higher priority.',
    ByAlgorithmPriorityValue:
      'Prioritise lessons by the activity priority value defined by optimisation algorithm in the activity details. A higher value indicates a higher priority.',
    Equal: 'All lessons are treated equally.',
    Random: 'Activities are prioritised randomly.',
  },
};
